import type React from "react";

type Props = {
  children: React.ReactNode;
};

export const LayoutPdp = ({ children }: Props): JSX.Element => {
  return (
    <div className="ps-page--product">
      <div className="ps-container">
        <div className="ps-page__container">
          <div className="ps-page__left">{children}</div>
        </div>
      </div>
    </div>
  );
};
